import { useEffect } from "react";
import {
  ArticleContent,
  CoachContent,
  CoachingContent,
  FormattedContent,
} from "../../../../../@types";
import { CoachListItem } from "../../../coaches";
import { handleButtonClick, hasButtonBeenProcessed } from "./buttonHandler";

export function Article({ content }: { content: FormattedContent | null }) {
  useEffect(() => {
    // Clean up any existing event listeners first
    const cleanupListeners = () => {
      const buttons = document.querySelectorAll('[id^="custom-button-"]');
      buttons.forEach((button) => {
        button.removeEventListener("click", handleButtonClick);
      });
    };

    // Clean up first
    cleanupListeners();

    // Setup with a small delay to ensure DOM is updated
    const setupTimerId = setTimeout(() => {
      const customButtons = document.querySelectorAll(
        '[id^="custom-button-"]'
      ) as NodeListOf<HTMLButtonElement>;

      customButtons.forEach((button) => {
        // Check if button has already been processed
        if (
          hasButtonBeenProcessed(button.id) ||
          button.dataset.buttonState === "true"
        ) {
          button.disabled = true;
          button.style.backgroundColor = "#e5e7eb";
        } else {
          button.disabled = false;
        }

        // Add fresh click handler
        button.addEventListener("click", handleButtonClick);
      });
    }, 100);

    // Clean up when unmounting or when content changes
    return () => {
      clearTimeout(setupTimerId);
      cleanupListeners();
    };
  }, [(content as ArticleContent)?.renderedContent]);

  return (
    <>
      <div
        className="py-6 "
        dangerouslySetInnerHTML={{
          __html: (content as ArticleContent)?.renderedContent || "",
        }}
      />
      {(content as CoachingContent)?.coaches?.map((c: CoachContent) => (
        <CoachListItem coach={c} />
      ))}
    </>
  );
}
